import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserRecord, handleReferral, getUserType } from '../supabaseAuth';
import { supabase } from '../supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      // Handle OAuth or magic link redirects
      const { error } = await supabase.auth.exchangeCodeForSession(window.location.href);

      if (error) {
        console.error('Error exchanging code for session:', error.message);
        navigate('/app/auth');
        return;
      }

      const { data: { session } } = await supabase.auth.getSession();

      if (session && session.user) {
        try {
          // Create user record via Edge Function
          await createUserRecord(session.user.id, session.user.email);

          // Handle referral acceptance
          const urlParams = new URLSearchParams(window.location.search);
          const referralToken = urlParams.get('referral');

          if (referralToken) {
            try {
              await handleReferral(session.user.id, referralToken);
            } catch (error) {
              console.error('Error handling referral:', error);
            }
          }

          // Get user type via Edge Function
          const userTypeId = await getUserType(session.user.id);

          // Navigate based on user type
          switch (userTypeId) {
            case 1:
              navigate('/app/client-or-consultant');
              break;
            case 2:
              navigate('/app/consultant-dashboard');
              break;
            case 3:
              navigate('/app/client-onboarding-personal');
              break;
            case 4:
              navigate('/app/client-dashboard');
              break;
            case 5:
              navigate('/app/system-admin-dashboard');
              break;
            default:
              navigate('/app/client-or-consultant');
          }
        } catch (error) {
          console.error('Error handling auth callback:', error.message);
          navigate('/app/auth');
        }
      } else {
        navigate('/app/auth');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return <div>Finalizing your account setup...</div>;
};

export default AuthCallback;